export default {
  state: {
    regions: null,
    locations: null,
    choosenRegion: null,
    chosenInstructor:null
  },
  getters: {
    getChoosen: state => state.choosenRegion,
    getRegions: state => state.regions,
    getLocations: state => state.locations,
  },
  mutations: {
    setChoosenRegion(state, region) {
      state.choosenRegion = region;
    },
    setChoosenInstructor(state, instructor) {
      state.chosenInstructor = instructor;
    },
    setRegions(state, regions) {
      state.regions = regions;
    },
    setLocations(state, locations) {
      state.locations = locations;
    }
  },
  actions: {
    downloadData({
      commit
    }, {
      url,
      commitName
    }) {
      return fetch(url)
        .then(response => response.json())
        .then((json) => {
          commit(commitName, json.results)
        })
    },
    getData({commit}, {url, headers}) {

        return fetch(url, {headers})
        .then(response => response.json())
        .then((json) => json)
    },
    updateChosenInstructor({
      commit
    }, {
      instructor
    }){
      commit('setChoosenInstructor', instructor)
    }
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/store/general.js